<template>
  <header class="header-wrapper pb-3">
    <div>
      <b-container class="d-block d-sm-none pt-3 pb-2">
        <h1 class="mb-0 text-uppercase font-weight-bold" style="font-size: 2rem;">Suksesbos</h1>
        <span class="text-muted">Pegel oleh nyerah ojo 💪 <span v-show="isOnwer"> | {{ userOnline }}</span>
        </span>
      </b-container>
    </div>
    <navbar></navbar>
  </header>
</template>

<style>
  .header-wrapper {
    position: relative;
    z-index: 1;
  }
</style>

<script>
  import navbar from './navbar.vue';

  export default {
    computed: {
      user() {
        return this.$store.state.authentication.user
      },
      isOnwer() {
        if ( this.user.role && 'owner' === this.user.role.slug ) {
          return true
        }

        return false
      },
      userOnline() {
        return this.$store.state.user_online
      }
    },
    components: {
      navbar
    }
  };
</script>
